export default __webpack_public_path__ + "static/media/wSweats_1.8db86577.bin";